module.exports = __webpack_public_path__ + "d6cdb6f93c5b52c6669e05f72e01601f.svg";